<template>
  <div>
    <div ref="index" class="row mb-2">
      <div class="col-md-6">
        <input
          v-model="query.generic" class="input form-control"
          @keypress.enter="$emit('find')"
          placeholder="Pesquisar por Serviço ou Apelido"
        >
        <search-icon @click="$emit('find')" class="icon icon-within"/>
      </div>

      <div v-if="$withPolicy('application', 'credentials/insert_or_update')" class="col-md-6">
        <button
            @click="$emit('createCredential')"
            class="btn btn-primary btn-lg"
        >
          Cadastrar credencial
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <Table
          :credentials="credentials"
          @showCredential="$emit('showCredential', $event)"
          @sendDeleteCredential="$emit('sendDeleteCredential', $event)"
        />

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="$emit('pagination', $event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Table from '@/components/credentials/container/Table'
  import { SearchIcon } from 'vue-feather-icons'
  import GetAccount from '@/mixins/GetAccount.vue';

  export default {
    components: { Pagination, SearchIcon, Table },
    mixins: [GetAccount],
    name: 'Index',
    props: {
      credentials: { required: true, type: Array },
      meta: { required: true, type: Object },
      query: { required: true, type: Object },
    }
  }
</script>

<style scoped>

</style>